import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../../components/header';
import ReloadButton from '../../components/reloadButton';
import Loading from '../../components/loading';
import ScreenToStoreContainer from '../../containers/screenToStore';
import { getPortals, getSelectedPortal } from '../../redux/portal/actions';

const ScreenToStoreScreen = () => {
  const portal = useSelector(getSelectedPortal);
  const portals = useSelector(getPortals);
  const [lastUpdated, setLastUpdated] = useState(0);

  if (portals === null) {
    return (
      <div className="d-flex flex-fill justify-content-center align-items-center">
        <Loading size={8} />
      </div>
    );
  }

  if (!portal?.id || !portal.activeFeatures?.includes('SCREEN_TO_STORE')) {
    return <Redirect to="/charts" />;
  }

  return (
    <div className="d-flex flex-column flex-fill">
      <Header title="Screen to Store" icon="store" actions={[
        { type: 'reactComponent', value: <ReloadButton key="reload" onPress={() => setLastUpdated(value => value + 1)} /> }
      ]} />
      <ScreenToStoreContainer key={portal.id} portal={portal} lastUpdated={lastUpdated} />
    </div>
  );
};

export default ScreenToStoreScreen;
